function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  width: 15,
  height: 2,
  rx: 1,
  fill: "#326DE6"
});

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  y: 5,
  width: 15,
  height: 2,
  rx: 1,
  fill: "#326DE6"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  y: 10,
  width: 15,
  height: 2,
  rx: 1,
  fill: "#326DE6"
});

var SvgHamburgerMenu = function SvgHamburgerMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    fill: "none"
  }, props), _ref, _ref2, _ref3);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxNSAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjE1IiBoZWlnaHQ9IjIiIHJ4PSIxIiBmaWxsPSIjMzI2REU2Ii8+CjxyZWN0IHk9IjUiIHdpZHRoPSIxNSIgaGVpZ2h0PSIyIiByeD0iMSIgZmlsbD0iIzMyNkRFNiIvPgo8cmVjdCB5PSIxMCIgd2lkdGg9IjE1IiBoZWlnaHQ9IjIiIHJ4PSIxIiBmaWxsPSIjMzI2REU2Ii8+Cjwvc3ZnPgo=";
export { SvgHamburgerMenu as ReactComponent };